<template>
    <section>
        <div class="center">
            <h4 class="label">
                {{ tabName }}
            </h4>
            <div class="down">
                <img src="/resources/png/Group 17.png" />
            </div>
            <div>
                <h2>We're still working on this tab..</h2>
            </div>
        </div>

        <div class="center content">
            <p class="font">
                Come back later to see our progress.<br />
                We usually release new updates each week.
            </p>
        </div>
    </section>
</template>

<script>
export default {

    props: {
        tabName: String,
    },
};
</script>

<style lang="scss" scoped>
.layout {
    display: flex;
}

.center {
    text-align: center;
    margin: $spacing-200;
}

.content {
    color: $color-gray-80;
    margin-bottom: 8rem;
    font-size: $small;
}

.down {
    margin: $spacing-600;
}

.label {
    font-size: $font-size-jumbo;
    margin-top: $spacing-400;
}
</style>
